import { render, staticRenderFns } from "./CreateCustomItem.vue?vue&type=template&id=48dd11c1&scoped=true&"
import script from "./CreateCustomItem.vue?vue&type=script&lang=js&"
export * from "./CreateCustomItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomItem.vue?vue&type=style&index=0&id=48dd11c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd11c1",
  null
  
)

export default component.exports